import React from 'react'
import {useClubPlatformContext} from "./store/useClubPlatformContext"
import ClubPlatformAuthCard from "./component/ClubPlatformAuthCard"
import {Card, Result, Skeleton, Space} from "antd"
import ClubPlatformUnAuthCard from "./component/ClubPlatformUnAuthCard"
import PlatformCode from "./common/ClubPlatformContanst"

const ClubPlatformLayout = () => {

    const {platformListState} = useClubPlatformContext()

    if (platformListState.isLoading) {
        return (
            <Skeleton active={true}/>
        )
    }

    if (platformListState.error) {
        return (
            <Result title={"获取关联平台信息失败"} subTitle={platformListState.error} status={"error"}/>
        )
    }

    return (
        <Card
            title={"授权平台"}
            style={{height: "100vh"}}
        >
            <Space direction={"horizontal"} size={"large"} style={{display: "flex"}}>
                {platformListState.relationStore.map((item, index) => {
                    const isBoundMerchant = item.value.shop
                    //先判断是否授权
                    if (!isBoundMerchant) {
                        return (
                            <ClubPlatformUnAuthCard key={index} title={item.platform.name}
                                                    platformId={item.platform.id} platFormCode={item.platform.id}/>
                        )
                    }

                    switch (item.platform.id) {
                        case PlatformCode.MeiTuan:
                            return (
                                <ClubPlatformAuthCard
                                    key={index}
                                    props={item}
                                    descChildren={<ClubPlatformAuthCard.MeiTuanDec/>}
                                    actionChildren={[<ClubPlatformAuthCard.UnbindStore key={"unbind"}/>]}
                                    avatar={<ClubPlatformAuthCard.Avatar/>}
                                />
                            )
                        case PlatformCode.DouYin:
                            return (
                                <ClubPlatformAuthCard
                                    key={index}
                                    props={item}
                                    descChildren={<ClubPlatformAuthCard.DouYinDec/>}
                                    actionChildren={[
                                        <ClubPlatformAuthCard.BindOrUnbindShop key={"bindOrUnbindShop"}/>,
                                        <ClubPlatformAuthCard.UnbindStore key={"unbind"}/>]}
                                    avatar={<ClubPlatformAuthCard.Avatar/>}
                                />
                            )
                    }


                })}
            </Space>
        </Card>
    )
}

export default ClubPlatformLayout


// WEBPACK FOOTER //
// ./src/containers/ClubPlatform/layout.js